import React from 'react';

export function useMicrositeMessaging(targetOrigin: string = '*') {
    const iframeRef = React.useRef<HTMLIFrameElement>(null);
    const listenersRef = React.useRef<Map<string, Set<(data: any) => void>>>(new Map());

    // Send message to iframe
    const sendMessage = React.useCallback((type: string, data: any = {}) => {
        if (iframeRef.current?.contentWindow) {
            iframeRef.current.contentWindow.postMessage(
                { type, data },
                targetOrigin
            );
        }
    }, [ targetOrigin ]);

    // Register message listener
    const onMessage = React.useCallback((type: string, callback: (data: any) => void) => {
        if (!listenersRef.current.has(type)) {
            listenersRef.current.set(type, new Set());
        }
        listenersRef.current.get(type)!.add(callback);
    }, []);

    // Setup message listener
    React.useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (targetOrigin !== '*' && event.origin !== targetOrigin) return;

            const { type, data } = event.data;
            const callbacks = listenersRef.current.get(type);

            if (callbacks) {
                callbacks.forEach(callback => callback(data));
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [ targetOrigin ]);

    return { iframeRef, onMessage, sendMessage };
}
